// Spektrix API configuration
export const spektrixApiUrl = 'https://tickets.norden.farm/nordenfarm/api/v3'

export const fetchOptions = {
  credentials: 'include',
  mode: 'cors',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}
